var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoDesktop = function SvgLogoDesktop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293.185,
    height: 50.86,
    viewBox: "0 0 293.185 50.86",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572",
    transform: "translate(-45.867 -45.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573",
    transform: "translate(109.721 55.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1572-2",
    "data-name": "Group 1572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M354.354,62.8,341.8,93.624h6l2.836-6.963h16.8l2.836,6.963h6.005L363.724,62.8Zm-1.6,18.666,6.282-15.423,6.282,15.423Z",
    transform: "translate(-241.576 -62.796)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M279.87,87.626Q277.409,86,271.93,85.49l-5.758-.557a10.319,10.319,0,0,1-3.064-.673,1.412,1.412,0,0,1-.93-1.323v-.279q0-.929,1.765-1.44a19.243,19.243,0,0,1,5.06-.511,19.585,19.585,0,0,1,5.828.627q1.834.627,1.834,2.02v.325h5.572v-.325a6.246,6.246,0,0,0-3.414-5.665q-3.412-2-9.634-2-6.036,0-9.4,1.88a5.772,5.772,0,0,0-3.367,5.223v.465a5.18,5.18,0,0,0,2.321,4.528q2.322,1.6,7.383,2.066l5.664.557a15.552,15.552,0,0,1,3.761.7,1.362,1.362,0,0,1,1.021,1.254v.278q0,2.275-7.2,2.275a22.213,22.213,0,0,1-6.223-.627q-1.949-.626-1.949-2.02v-.325h-5.572v.325a6.222,6.222,0,0,0,3.6,5.641q3.6,2.02,10.005,2.02,6.128,0,9.612-1.9t3.482-5.293v-.465A5.239,5.239,0,0,0,279.87,87.626Z",
    transform: "translate(-203.184 -68.542)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M315.8,62.8h-5.572v23.03a7.444,7.444,0,0,0,2.229,5.711,8.534,8.534,0,0,0,6.082,2.09h7.382V88.7h-6.871a3.383,3.383,0,0,1-2.415-.789,2.98,2.98,0,0,1-.836-2.275V75.426h10.121V70.5H315.8Z",
    transform: "translate(-227.509 -62.796)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M412.595,78.973l-.139-2.275h-5.2V99.821h5.572V84.313q2-2.692,6.779-2.693h4.846V76.7h-4.1A12.41,12.41,0,0,0,412.595,78.973Z",
    transform: "translate(-270.741 -68.99)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M475.345,75.693a13.531,13.531,0,0,0-5.5,1.091,11,11,0,0,0-4.2,3.227q-2.924-4.318-9.658-4.318a11.711,11.711,0,0,0-8.218,3.018l-.186-2.461h-5.2V99.374h5.571v-14.3a7.667,7.667,0,0,1,3.018-3.11,8.7,8.7,0,0,1,4.457-1.161,6.449,6.449,0,0,1,4.876,1.788,7.047,7.047,0,0,1,1.718,5.084v11.7h5.572v-11.7a21.167,21.167,0,0,0-.14-2.507,8.025,8.025,0,0,1,3.088-3.18,8.78,8.78,0,0,1,4.527-1.184,6.526,6.526,0,0,1,4.9,1.788,6.99,6.99,0,0,1,1.741,5.084v11.7h5.572v-11.7q0-5.8-3.065-8.892T475.345,75.693Z",
    transform: "translate(-286.391 -68.542)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M191.912,62.8H161.035V68h16.42v.539l-3.883,2.821V93.627h5.8V68h12.536Z",
    transform: "translate(-161.035 -62.796)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M225.055,78.757q-3.551-3.065-9.866-3.064a17.461,17.461,0,0,0-7.29,1.416,10.764,10.764,0,0,0-4.783,4.063,11.4,11.4,0,0,0-1.671,6.222v.928a11.2,11.2,0,0,0,1.671,6.152,10.831,10.831,0,0,0,4.76,4.041,17.417,17.417,0,0,0,7.313,1.416q5.942,0,9.448-2.229a8.21,8.21,0,0,0,3.878-5.758h-6.05a3.731,3.731,0,0,1-2.076,1.951,12.41,12.41,0,0,1-5.2.929,9.953,9.953,0,0,1-5.5-1.346,5.146,5.146,0,0,1-2.391-3.807h21.313V87.208A10.571,10.571,0,0,0,225.055,78.757Zm-17.62,6.5a4.845,4.845,0,0,1,.788-1.742,6.037,6.037,0,0,1,2.741-2.019,11.39,11.39,0,0,1,4.179-.7,8.931,8.931,0,0,1,5.678,1.626,4.841,4.841,0,0,1,1.8,2.83Z",
    transform: "translate(-179.04 -68.542)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M545.749,76.7,537.5,96.95,529.251,76.7h-6.005l9.418,23.123h3.667l-3.215,7.893h6L551.754,76.7Z",
    transform: "translate(-322.422 -68.99)",
    fill: "#183029"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1574",
    "data-name": "Group 1574",
    transform: "translate(45.867 45.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M70.253,45.868h-3.5l-2.528,7.78H56.04L54.958,56.98H66.642Z",
    transform: "translate(-49.917 -45.868)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M120.939,56.98l-1.083-3.332h-8.18l-2.528-7.78h-3.5l3.611,11.112Z",
    transform: "translate(-72.502 -45.868)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M126.93,105.859l2.834-2.059-2.528-7.78,6.618-4.808-1.083-3.332-9.452,6.867Z",
    transform: "translate(-80.377 -64.587)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M86.224,92.836,88.883,90.9l2.659-1.932L86.968,74.9l11.974-8.7L97.927,63.07l-1.015-3.125h-14.8L77.537,45.868H70.964L66.39,59.945h-14.8L50.573,63.07,49.557,66.2l11.976,8.7L56.959,88.974,59.616,90.9l2.659,1.932,11.974-8.7ZM65.449,73.624,51.209,63.277h17.6l5.44-16.741,5.44,16.741h17.6L83.051,73.624l5.44,16.741L74.3,80.057l-.054-.039L60.011,90.363Z",
    transform: "translate(-47.511 -45.868)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M93.115,130.427l2.834-2.059L86.5,121.5l-9.452,6.867,2.834,2.059,6.618-4.808Z",
    transform: "translate(-59.759 -79.567)",
    fill: "#183029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M46.949,87.879l-1.083,3.332,6.619,4.809L49.958,103.8l2.834,2.059L56.4,94.747Z",
    transform: "translate(-45.867 -64.586)",
    fill: "#183029"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoDesktop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoDesktop.2f74b13d.svg";
export { ForwardRef as ReactComponent };